import { client } from './client';
export function getArtQueue(levelId) {
    return client.get(`/levels/${levelId}/art/queue`);
}
/** Persist the style text without generating anything. */
export function saveArtStyle(levelId, style) {
    return client.put(`/levels/${levelId}/art/style`, { style });
}
// Render ONE image for a slot (this is also Retry). Optional content/style override
// the stored ones (an edited style is saved level-wide as a side effect). Long job
// (a fal round trip) — give it a generous timeout.
export function generateArtSlot(levelId, slotKey, opts) {
    return client.post(`/levels/${levelId}/art/slot/${encodeURIComponent(slotKey)}/generate`, { content: opts === null || opts === void 0 ? void 0 : opts.content, style: opts === null || opts === void 0 ? void 0 : opts.style }, { timeout: 5 * 60 * 1000 });
}
export function approveArtSlot(levelId, slotKey) {
    return client.post(`/levels/${levelId}/art/slot/${encodeURIComponent(slotKey)}/approve`, {});
}
/** Attach an already-uploaded /uploads/… image as the slot's candidate (manual path). */
export function setArtSlotCandidate(levelId, slotKey, imageUrl) {
    return client.post(`/levels/${levelId}/art/slot/${encodeURIComponent(slotKey)}/candidate`, { imageUrl });
}
